import React from "react";
import { Phone } from "lucide-react";
import { useContent } from "../ContentContext";

export default function StickyCTA({ onEstimate }) {
  const { company } = useContent();
  return (
    <div className="fixed bottom-0 left-0 w-full z-40 sm:bottom-6 sm:left-1/2 sm:-translate-x-1/2 sm:w-auto">
      <div className="flex gap-0 sm:gap-3 sm:rounded-full sm:p-2 shadow-2xl" style={{ background: "var(--pine)" }}>
        <a href={`tel:${company.phoneRaw}`} data-testid="sticky-call"
           className="flex-1 sm:flex-none flex items-center justify-center gap-2 py-4 sm:py-3 sm:px-6 font-semibold text-sm"
           style={{ color: "var(--moss)" }}>
          <Phone size={18} style={{ color: "var(--brass)" }} /> <span className="hidden sm:inline">{company.phone}</span><span className="sm:hidden">Call Now</span>
        </a>
        <button data-testid="sticky-estimate" onClick={onEstimate}
                className="flex-1 sm:flex-none py-4 sm:py-3 sm:px-6 sm:rounded-full font-semibold text-sm transition-transform hover:scale-105"
                style={{ background: "var(--sun)", color: "var(--pine)" }}>
          Request a Free Estimate
        </button>
      </div>
    </div>
  );
}
